export class AppConstants {
    public static ONCOMING_UNPAID_PAYMENTS_DAYS_LIMIT = 30
}